import 'css-chunksrc/client/scenes/removeIdentityProvider/styles.scss';export default {
  "removeIdentityProvider": "_removeIdentityProvider_1sgsa_1",
  "header": "_header_1sgsa_8",
  "message": "_message_1sgsa_12",
  "button": "_button_1sgsa_17"
};